import React, { useState } from "react";
import { Collapse } from "antd";
import { useNavigate } from "react-router-dom";
import SubHeader from "../../../components/SubHeader/SubHeader";
import "../../../styles/globals.css";
import "./FaqListPage.css";

/**
 * よくある質問画面用のコンポーネント
 * @param {} なし
 * @return {}  なし
 */
function FaqListPage() {
  const navigate = useNavigate();
  const { Panel } = Collapse;

  // FAQカテゴリと質問のデータ
  const faqCategories = [
    {
      category: "ログイン",
      items: [
        {
          question: "Medicom診察サポートのウェブ画面にログインしたい/マイページの各種機能について",
          answer: "医療機関の予約用URL、以下URLからもログイン可能です。\nログイン後右上のボタンから各種確認・操作が可能です。\n\nhttps://pcedx-p.medicomcloud.com/mypage/account-login\n\nマイページ：本人情報・家族情報等各種設定のご変更が可能です。"
        },
        {
          question: "Medicom診察サポートウェブ画面に再ログインできない",
          answer: "Medicom診察サポートのウェブ画面はメールアドレスとパスワードでアカウントを管理しております。\n\n【ご参考】ウェブ画面ログインURL\nhttps://pcedx-p.medicomcloud.com/mypage/account-login"
        }
      ]
    },
    {
      category: "登録",
      items: [
        {
          question: "メールアドレスの認証メールが届かない",
          answer: "迷惑メールフォルダに届いていないかご確認ください。\nまた、＠rep.medicomcloud.comを有効にしてください。\n\nもしくは、メールアドレスを変更して行ってください。"
        },
        {
          question: "認証コード番号が届かない",
          answer: "迷惑メールフォルダに届いていないかご確認ください。\nまた、＠rep.medicomcloud.comを有効にしてください。"
        }
      ]
    },
    {
      category: "登録情報変更",
      items: [
        {
          question: "電話番号を変更したい",
          answer: "マイページ＞個人情報変更より変更ください"
        },
        {
          question: "メールアドレスを変更したい",
          answer: "マイページ＞メールアドレス変更より変更ください"
        },
        {
          question: "パスワードを変更したい",
          answer: "マイページ＞パスワード変更より変更ください"
        },
        {
          question: "退会したい",
          answer: "マイページ＞退会手続きから退会ください\nお客様のデータが全て削除されますので、ご注意ください。"
        }
      ]
    },
    {
      category: "予約",
      items: [
        {
          question: "予約の仕方を知りたい",
          answer: "予約方法は医療機関のウェブサイトやお電話のみでの受付など医療機関により方法が異なります。\n大変恐れ入りますが、ウェブサイトやお電話にて医療機関へのご確認をお願いいたします。"
        },
        {
          question: "予約の確認をしたい",
          answer: "メールアドレスに届いている予約確認・変更・キャンセルメールからご確認ください。"
        },
        {
          question: "Medicom診察サポートの予約をキャンセルしたい・変更したい",
          answer: "メールアドレスに届いている予約確認・変更・キャンセルメールからキャンセル、変更ください。\nもしくは直接医療機関にお電話ください。"
        },
        {
          question: "予約をしたのに患者様に予約完了メールが届かない",
          answer: "予約時メールアドレスが設定されていないか、メールアドレスに誤りがある。もしくは迷惑メールフォルダに届いていないかご確認ください。"
        },
        {
          question: "予約していないのに予約メールが届く",
          answer: "医療機関にて予約登録を行った場合に、登録メールアドレスに予約内容が送信されます。\nお心当たりがない場合には、お手数ですが医療機関へ直接ご確認をお願いいたします。"
        },
        {
          question: "医療機関の診療時間が分かりません",
          answer: "医療機関のホームページやお電話で直接ご確認ください"
        },
        {
          question: "家族の分も予約できますか？",
          answer: "マイページ＞家族設定からあらかじめご家族の方をご登録ください。\n家族登録後に予約しますと、予約の受診者にご家族の方が選択できます。\n1アカウント（家族分含め）１医療機関あたり最大10件予約ができます。"
        },
        {
          question: "複数の診療科を同時に予約できますか？",
          answer: "できます。1アカウント（家族分含め）１医療機関あたり最大10件予約ができます。"
        },
        {
          question: "キャンセル待ちはできますか？",
          answer: "キャンセル待ちはできません。ただちに診察が必要な場合などは、医療機関にお問合せください。"
        }
      ]
    },
    {
      category: "問診",
      items: [
        {
          question: "問診が届かない",
          answer: "迷惑メールフォルダに届いていないかご確認ください。\nまた、＠rep.medicomcloud.comを有効にしてください。"
        },
        {
          question: "問診票を途中で保存できますか？",
          answer: "できません、必ず必須項目を入力していただき、送信ください。"
        },
        {
          question: "誤って送信してしまいました。修正できますか？",
          answer: "修正できます。メールアドレスに送られています、問診のお願いのメールから、再度問診を行ってください。"
        },
        {
          question: "問診の回答内容はどこまで医師に伝わりますか？",
          answer: "問診の回答は全て伝わります。メールで伝えづらい内容については、診察時に医師に直接お伝えください。"
        },
        {
          question: "問診の入力を代理で行っても大丈夫ですか？",
          answer: "大丈夫です。念のため、予約の確認時に、医療機関にお伝えしたいことに入力、もしくは医療機関、診察時に医師に代理入力してもらった旨をお伝えください。"
        }
      ]
    }
  ];

  return (
    <div className="faq-list">
      <SubHeader
        pageTitle={"よくある質問"}
        onClickBack={() => navigate("/mypage/menu")}
      />
      <div className="main-area">
        <div className="title">よくある質問</div>
        <div className="detail">Medicom診察サポートに関するよくある質問をご案内します。</div>
        
        {faqCategories.map((category, index) => (
          <div key={index} className="faq-category">
            <h3 className="category-title">{category.category}</h3>
            <Collapse className="faq-accordion">
              {category.items.map((item, itemIndex) => (
                <Panel 
                  header={item.question} 
                  key={`${index}-${itemIndex}`}
                  className="faq-panel"
                >
                  <div className="faq-answer">
                    {item.answer.split('\n').map((line, lineIndex) => (
                      <React.Fragment key={lineIndex}>
                        {line}
                        {lineIndex < item.answer.split('\n').length - 1 && <br />}
                      </React.Fragment>
                    ))}
                  </div>
                </Panel>
              ))}
            </Collapse>
          </div>
        ))}
        
        <div className="back-to-mypage-container">
          <button 
            className="back-to-mypage-button" 
            onClick={() => navigate("/mypage/menu")}
          >
            マイページに戻る
          </button>
        </div>
      </div>
    </div>
  );
}

export default FaqListPage;